import React from "react";
import { Logo } from "./Logo";
import { Instagram, Linkedin, Mail, MapPin } from "lucide-react";
import { waLink, telLink, CONTACT } from "../lib/execora";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-white border-t border-slate-100"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
        {/* TOP */}
        <div className="flex flex-col lg:grid lg:grid-cols-12 gap-10">
          {/* LEFT */}
          <div className="lg:col-span-5">
            <Logo size="lg" />

            <p className="mt-4 max-w-sm text-sm leading-relaxed text-slate-600">
              Execora helps you get things from nearby shops and services —
              without stepping out.
            </p>

            <div className="mt-4 flex items-center gap-2 text-sm text-slate-600">
              <MapPin className="h-4 w-4 text-[#65a30d]" />
              Indiranagar, Bengaluru
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-col gap-3 sm:flex-row">
              <a
                href={waLink()}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp-cta"
                className="w-full rounded-xl bg-[#84cc15] px-4 py-3 text-center text-sm font-semibold text-white transition hover:bg-[#65a30d] sm:w-auto"
              >
                WhatsApp us
              </a>

              <a
                href={telLink()}
                data-testid="footer-call-cta"
                className="w-full rounded-xl border border-slate-200 px-4 py-3 text-center text-sm font-semibold text-slate-700 transition hover:border-slate-300 sm:w-auto"
              >
                {CONTACT.callDisplay}
              </a>
            </div>
          </div>

          {/* RIGHT */}
          <div className="lg:col-span-7">
            <div className="grid grid-cols-2 gap-8 sm:grid-cols-3 lg:ml-auto lg:max-w-2xl">
              {/* Serving */}
              <div>
                <div className="text-xs font-semibold uppercase tracking-widest text-slate-500">
                  Serving
                </div>

                <ul className="mt-4 space-y-2 text-sm text-slate-700">
                  <li>Indiranagar</li>
                  <li>
                    Domlur <span className="text-slate-400">(soon)</span>
                  </li>
                  <li>
                    HAL <span className="text-slate-400">(soon)</span>
                  </li>
                  <li>
                    Koramangala{" "}
                    <span className="text-slate-400">(soon)</span>
                  </li>
                  <li>
                    HSR <span className="text-slate-400">(soon)</span>
                  </li>
                </ul>
              </div>

              {/* Connect */}
              <div>
                <div className="text-xs font-semibold uppercase tracking-widest text-slate-500">
                  Connect
                </div>

                <ul className="mt-4 space-y-3 text-sm text-slate-700">
                  <li>
                    <a
                      href="https://www.instagram.com/execora.in"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center gap-2 transition hover:text-slate-900"
                    >
                      <Instagram className="h-4 w-4" />
                      Instagram
                    </a>
                  </li>

                  <li>
                    <a
                      href="https://www.linkedin.com/company/execora-technologies/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center gap-2 transition hover:text-slate-900"
                    >
                      <Linkedin className="h-4 w-4" />
                      LinkedIn
                    </a>
                  </li>

                  <li>
                    <a
                      href="mailto:info@execora.in"
                      className="flex items-center gap-2 transition hover:text-slate-900"
                    >
                      <Mail className="h-4 w-4" />
                      info@execora.in
                    </a>
                  </li>
                </ul>
              </div>

              {/* Legal */}
              <div>
                <div className="text-xs font-semibold uppercase tracking-widest text-slate-500">
                  Legal
                </div>

                <ul className="mt-4 space-y-3 text-sm text-slate-700">
                  <li>
                    <a
                      href="/terms-and-conditions"
                      className="transition hover:text-slate-900"
                    >
                      Terms & Conditions
                    </a>
                  </li>

                  <li>
                    <a
                      href="/privacy-policy"
                      className="transition hover:text-slate-900"
                    >
                      Privacy Policy
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* BOTTOM */}
        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-slate-100 pt-6 text-center text-xs text-slate-500 sm:flex-row sm:text-left">
          <div>
            © {new Date().getFullYear()} Execora Technologies Private Limited.
            All rights reserved.
          </div>

          <div>Made with 🌿 in Bengaluru, India</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
